/** Paket-Kachel im Schnellstart (8a): Icon-Tile statt Foto (kein imageUrl im echten Pkg-Modell,
 *  s. Plan-Abweichung), Preis/Gast + Positionsanzahl, Klick legt eine NEUE Variante an und
 *  uebernimmt das Paket additiv dort hinein (Punkt 2, 20.08.2026 - siehe applyPackage()). */
import { paketPreisart } from "@maestro/pricing";
import type { Pkg } from "../pages/builder";
import { money } from "./format";
import { Icon } from "./components";
import { AllergenBadges } from "./lmiv";

/** Icon je Paket-Art -- gleiches Muster wie KIND_ICON in catalog.tsx. Nur von `PackageTile`
 *  gebraucht, deshalb (anders als `Pkg`) komplett hierher verschoben statt zurueckimportiert. */
const PKG_KIND_ICON: Record<string, string> = { menu: "restaurant_menu", buffet: "dining", flat: "payments" };

export function PackageTile({ pkg, busy, onApply }: { pkg: Pkg; busy: boolean; onApply: () => void }) {
  return (
    <button
      type="button"
      disabled={busy}
      onClick={onApply}
      className="w-[168px] shrink-0 rounded-[11px] border border-outline-variant/60 bg-surface-container-low p-3 text-left transition-colors hover:border-primary/50 hover:bg-primary/[0.05] disabled:cursor-wait disabled:opacity-60 dark:border-outline/30 dark:bg-surface-variant/10 lg:w-auto lg:shrink"
    >
      <div className="mb-2 grid h-9 w-9 place-items-center rounded-[9px] bg-primary/12 text-primary">
        {busy ? <Icon name="sync" className="animate-spin text-[18px]" /> : <Icon name={PKG_KIND_ICON[pkg.kind] ?? "inventory_2"} className="text-[18px]" />}
      </div>
      <p className="truncate text-[12.5px] font-semibold text-on-background dark:text-inverse-on-surface">{pkg.name}</p>
      {/* Migration 242: Ein Pauschalpaket (kind = "flat") traegt EINEN Betrag fuer die ganze
          Veranstaltung. „8.500 € /Gast" an der Kachel waere dieselbe Verwechslung, die im
          Angebot 595.000 € ergeben hat — nur in der Anzeige. Welche Spalte gilt, entscheidet
          `paketPreisart()` aus @maestro/pricing, nicht diese Datei. */}
      <p className="mt-0.5 text-[13px] font-bold text-primary">
        {money(paketPreisart(pkg).betragCents)}{" "}
        <span className="text-[10.5px] font-medium text-secondary-fixed-dim">{paketPreisart(pkg).pauschal ? "pauschal" : "/Gast"}</span>
      </p>
      <p className="mt-0.5 text-[10.5px] text-secondary-fixed-dim">
        {pkg.itemCount ?? 0} Positionen
        {pkg.hasArchivedItems && (
          <span className="ml-1 rounded bg-secondary/15 px-1 py-0.5 font-label-md text-[9.5px] font-semibold text-secondary dark:text-[#b8ae9e]" title="Enthält archivierte Positionen (Karte ersetzt?) — Paket prüfen.">
            prüfen
          </span>
        )}
      </p>
      {/* LMIV: Allergen-Union der Gänge schon an der Paket-Kachel sichtbar. */}
      {(pkg.itemCount ?? 0) > 0 && (
        <span className="mt-1 flex flex-wrap items-center gap-1">
          {pkg.allergensResolved === false && (
            <span title="Allergene unvollständig gepflegt (LMIV)">
              <Icon name="warning" className="text-[13px] text-secondary dark:text-[#b8ae9e]" />
            </span>
          )}
          <AllergenBadges allergens={pkg.allergensResolved === false && (pkg.allergenUnion ?? []).length === 0 ? null : (pkg.allergenUnion ?? [])} dietary={pkg.dietaryAll} />
        </span>
      )}
    </button>
  );
}
